import { Component, OnInit, OnDestroy, Renderer2, ElementRef, ViewChildren, QueryList, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { DirectionService } from '../../direction.service';
import { DataSharingService } from '../data-shering-service/data-sharing.service';
import { DialogService } from '../../dialog/dialog.service';
import { AuthService } from "../../auth/auth.service";

import { UsersService } from 'src/app/super-management/user/users.service';
import { BranchesService } from 'src/app/super-management/branch/branches.service';
import { ClustersService } from 'src/app/main-section/choose-branch/clusters.service';

import { Subject } from 'rxjs';
import { set } from 'lodash';

@Component({
  selector: 'app-choose-printer',
  templateUrl: './choose-printer.component.html',
  styleUrls: ['./choose-printer.component.scss'],
  host: {
    class: 'fill-screen'
  }
})

export class ChoosePrinterComponent implements OnInit, OnDestroy {

  isRTL: boolean = true;
  isDarkMode: boolean = false;
  isLoading: boolean = false;
  private directionSubscription: Subscription;
  public clusterName: string = '';
  public printingService: string = '';
  public branch: string = '';
  public cluster: any;
  public branches: any[] = [];
  public filteredBranches: { name: string, systems: string[] }[] = [];
  private dataServiceSubscription: Subscription;
  private branchSubscription: Subscription;
  public nonExistingBranch: string = '';
  public nonExistingBranchMessage: string = '';
  public nonExistingBranchIndex: number = undefined;
  continueToPrinterText: string = '';
  userIsAuthenticated = false;
  private authListenerSubs: Subscription;
  allBranches: any;
  private destroy$ = new Subject<void>();
  @ViewChildren('branchElement') branchElements: QueryList<ElementRef>;
  isInitialized: boolean = true;
  isBranchSet: boolean = false;
  public hoveredPrintingService: string = '';

  isLoadingbranch: boolean = false;
  isAnimateBranchBtn: boolean = false;
  isScreenWide: boolean = false;

  constructor(
    public directionService: DirectionService,
    private dataSharingService: DataSharingService,
    private router: Router,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private authService: AuthService,
    private usersService: UsersService,
    private branchesService: BranchesService,
    private renderer: Renderer2,
    private clusterssService: ClustersService
  ) {
    this.translateService.onLangChange.subscribe(() => {
      this.updateTooltipContent();
    });
  }

  async ngOnInit() {
    this.isLoading = true;
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authListenerSubs = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
      });

    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.isScreenWide = window.innerWidth > 786;

    this.dataSharingService.getPrintingService().subscribe((value) => {
      if (value && value !== '') {
        this.printingService = value;
      }
    });

    this.dataServiceSubscription = this.dataSharingService.getCluster()
      .subscribe((value) => {
        if (!value) {
          this.router.navigate(['/']);
        }
        if (this.clusterName !== value) {
          this.isInitialized = true;
        }
        this.clusterName = value;
        // console.log('clusterName:', this.clusterName);
        this.branchSubscription = this.dataSharingService.getBranch()
          .subscribe((value) => {
            this.branch = value;
          });
        this.updateTooltipContent();
      });

    try {
      this.cluster = await this.clusterssService.getBranchesByClusterName(this.clusterName).toPromise();
      if (!this.cluster.plotter?.some(printer => printer.serial_name === this.branch) &&
        !this.cluster.express?.some(printer => printer.serial_name === this.branch)) {
        this.branch = "";
      } else {
        this.showActionBtn();
      }
      this.isLoading = false;
    } catch (error) {
      console.error('Error fetching and transforming branches:', error);
    }
  }

  showActionBtn() {
    setTimeout(() => {
      if (this.branch && this.branch !== '') {
        this.isBranchSet = true;
      } else {
        this.isBranchSet = false;
      }
    }, 120);
  }

  sortBranches() {
    if (this.isInitialized) {
      this.filteredBranches.sort((a, b) => {
        if (a.name === this.branch) return -1;
        if (b.name === this.branch) return 1;
        return 0;
      });
    }
    this.isInitialized = false;
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    this.authListenerSubs.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onChooseBranch(branchName: string, service: string) {
    this.printingService = service;
    this.dataSharingService.setPrintingService(this.printingService);
    if (!this.branch || this.branch === '') {
      this.isLoadingbranch = true;
    }
    this.isLoading = true;
    this.branch = branchName;
    this.onSetBranch();
  }

  async onSetBranch() {
    this.dataSharingService.setBranch(this.branch);
    if (this.userIsAuthenticated) {
      await this.dataSharingService.setPrintingService(this.printingService);
      await this.dataSharingService.setBranch(this.branch);
      this.authService.updateAuthData(this.printingService, this.branch);
      this.usersService.updateUserPlace(
        this.printingService,
        this.branch
      ).subscribe(response => {
        this.isLoadingbranch = false;
        this.router.navigate(['/print']);
      });
    } else {
      this.isLoading = false;
      this.openLoginDialog();
    }
  }

  openLoginDialog() {
    this.dialogService.onOpenLoginDialog(this.printingService, this.branch);
  }

  updateTooltipContent() {
    this.continueToPrinterText =
      this.translateService.instant('choose-system.continue-to-branch') +
      this.translateService.instant('choose-branch.naming.' + this.printingService + '.' + this.branch)
  }

  animateOut() {
    setTimeout(() => {
      this.isAnimateBranchBtn = true;
      setTimeout(() => {
        this.isAnimateBranchBtn = false;
      }, 400);
    }, 10);
  }

  getIsPics(printer: any) {
    if (printer && printer.isPicsPrinter) {
      return 'pics';
    } else {
      return 'express';
    }
  }

  onHoverPrintingService(value: string) {
    this.hoveredPrintingService = value;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isScreenWide = window.innerWidth > 768;
  }

  // ================== 
}
